import { render } from "./PaginatorItemsPerPage.vue?vue&type=template&id=2396b666&ts=true"
import script from "./PaginatorItemsPerPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginatorItemsPerPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/core/report/components/PaginatorItemsPerPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2396b666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2396b666', __exports__)) {
    console.log('reload')
    api.reload('2396b666', __exports__)
  }
  
  module.hot.accept("./PaginatorItemsPerPage.vue?vue&type=template&id=2396b666&ts=true", () => {
    console.log('re-render')
    api.rerender('2396b666', render)
  })

}


export default __exports__